import { Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { HERO_IMAGE, PHONE_TEL } from "@/lib/site";

export const Hero = () => {
  return (
    <section
      id="startseite"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Professionelle Reinigungsfirma in Leonberg – Detailreinigung einer Oberfläche"
          width="1264"
          height="848"
          fetchPriority="high"
          decoding="async"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-[#0A192F]/80" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F]/90 via-[#0A192F]/40 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8 w-full pt-28 pb-20">
        <div className="max-w-3xl animate-fade-up">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#5CB3FF] mb-5">
            Reinigungsservice · Leonberg &amp; Umgebung
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.08]">
            Professionelle Reinigungsfirma in Leonberg und Umgebung
          </h1>
          <p className="mt-6 text-base md:text-lg text-slate-200 leading-relaxed max-w-2xl">
            Zuverlässig, gründlich und flexibel – für Wohnungen, Häuser, Büros
            und Treppenhäuser.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Button
              asChild
              size="lg"
              data-testid="hero-primary-cta"
              className="rounded-full bg-[#0077E6] px-8 h-14 text-base text-white hover:bg-[#005bb5] transition-transform hover:scale-105 active:scale-95"
            >
              <a href="#kontakt">
                Unverbindliches Angebot anfordern
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              data-testid="hero-secondary-cta"
              className="rounded-full px-8 h-14 text-base border-2 border-white/70 bg-transparent text-white hover:bg-white hover:text-[#0A192F] transition-colors"
            >
              <a href={`tel:${PHONE_TEL}`}>
                <Phone className="mr-2 h-5 w-5" />
                Jetzt anrufen
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
